import { StatusId } from '../../types';
import { DepotOffre, RefusConsultation } from './historique';

// Etat de reponse d'un candidat a la consultation, pour la section "Contenu des plis".
//
// La source est l'HISTORIQUE, pas le statut de la commande. Le statut continue d'evoluer APRES
// la reponse -- 5 -> 10 -> 11 quand le retenu signe, -> 6 quand l'offre est ecartee a la cloture --
// donc s'y fier fait disparaitre le contenu du pli au moment ou il devient definitif.
// L'id_status ne tranche plus que les deux etats sans evenement dedie : expiration et annulation.
//
// Regle jumelle cote back-office : partials/commandes-modal-detail.blade.php ($statutReponse).

export type EtatReponse = 'repondu' | 'refuse' | 'expire' | 'annule' | 'attente';

export interface StatutReponse {
  etat: EtatReponse;
  // Date de l'evenement qui fonde l'etat (depot ou refus), null pour les etats sans evenement.
  // Jamais commande.updated_at : celui-ci bouge a chaque sauvegarde (notation, cloture) et
  // datait donc le fait bien apres qu'il soit survenu.
  date: string | null;
}

export const getStatutReponse = (
  idStatus?: number,
  depot?: DepotOffre,
  refus?: RefusConsultation,
): StatutReponse => {
  // Un depot prime sur tout le reste : le candidat a repondu, quoi qu'il soit advenu de son
  // offre ensuite (retenue et signee, ou ecartee a la cloture).
  if (depot) return { etat: 'repondu', date: depot.date };
  // 'Refus' = le prestataire decline la consultation. A ne pas confondre avec 'Refusé', le rejet
  // de l'offre par l'acheteur a la cloture : les deux posent la commande au statut 6, mais le
  // second suppose justement un depot, deja capte ci-dessus.
  if (refus) return { etat: 'refuse', date: refus.date };
  if (idStatus === StatusId.Expirer) return { etat: 'expire', date: null };
  if (idStatus === StatusId.Annule) return { etat: 'annule', date: null };
  return { etat: 'attente', date: null };
};

// A-t-on de quoi afficher le pli (numero d'offre, date, deposant, IP, PDF) ?
export const aRepondu = (statut: StatutReponse): boolean => statut.etat === 'repondu';
